import React from "react";
import { PageList } from "../components/pageList";
import { ClaimTableSchema } from "../schema/table/claim";
import { ClaimAddForm, ClaimEditForm } from "../schema/form/claim";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const ProductCategory = ({ title = "Product Category" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"productCategory"}
      tableSchema={getTableSchema("productCategory")}
      formSchema={getFormSchema("productCategory")}
      showImport={false}
      searchByTextField={true}
      showGoBack={true}
      backRoute="/setting"
      // stats={{
      //   component: ProjecPageStats,
      //   props: {
      //     mb: 35,

      //   },
      // }}
    />
  );
};

export default ProductCategory;
